import { createContext, useContext } from "react";
import { Platform } from "./../../../types/src/types";

const PlatformContext = createContext<Platform | undefined>(undefined);
const usePlatformContext = () => useContext(PlatformContext);

export { PlatformContext, usePlatformContext };
